import Vue from "vue";
import Vuex from "vuex";

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

/**
 * MODULES
 */
import searchFromApi from './search/searchApi';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {

        postsData: {
            post: [],
            page: [],
            attachment: []
        },
        authors: [],
        taxonomies: {
            category: []
        },
        navigations: {},
        pageIsLoading: true,

        storeVersion: false,
        cacheKey: 'tb_app_cache',
        loadedEverything: {
            working: false,
            status: false,
        },
        loadedTaxonomies: {
            working: false,
            status: false,
        },


    },
    modules: {
        searchFromApi
    },
    getters,
    mutations,
    actions
});
